import { PlusThin } from "assets/svg";
import styled from "styled-components";

export const Container = styled.div``;

export const Header = styled.div`
  margin-bottom: ${({ theme }) => theme.margin.m20};
`;

export const Content = styled.div``;

export const CompaniesListSection = styled.div`
  margin-top: ${({ theme }) => theme.margin.m8};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.padding.p8};
`;

export const CompaniesList = styled.div`
  position: relative;
  display: flex;
  gap: ${({ theme }) => theme.padding.p8};
  flex-direction: column;
  min-height: 300px;
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.margin.m24};
  align-self: center;
`;

export const AddNewCompanyButtonIcon = styled(PlusThin)`
  path {
    stroke: ${({ theme }) => theme.colors.colorsNew.primary["500_main"]};
  }
`;
